var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news-content"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"news-item flex fd-c ai-c"},[_c('div',{staticClass:"t1 flex fd-c ai-c",domProps:{"innerHTML":_vm._s(item.info)}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }